import { useEffect } from 'react'

import { View } from '@/lib/api/client'
import { useUpdateView } from '../../services/queries/views'

/**
 * sets the needsUpdate flag to true for all views with explosions
 * for the viewWorker to handle once the new cad version is loaded
 */
export const useCheckImageDataNeedsUpdate = ({ views }: { views: View[] }) => {
  const { mutateAsync: updateView } = useUpdateView()

  useEffect(() => {
    async function checkImageDataNeedsUpdate() {
      const viewsNeedingUpdate = views.filter(
        (view) => view.image_data?.needsUpdate,
      )

      for (let view of viewsNeedingUpdate) {
        if (!view.id) {
          console.warn('Unable to update view due to missing view id')
          continue
        }

        const data = view.image_data
        data.needsUpdate = Boolean(data.explosions)

        await updateView({
          viewId: view.id,
          values: {
            ...view,
            image_data: data,
            document_page_id: view.document_page ?? null,
          },
        })
      }
    }

    void checkImageDataNeedsUpdate()
  }, [views, updateView])
}
